// ============================================================================
// FILE: frontend/src/modules/ppe/pages/execution/material-issue/materialIssueService.js
// MODULE: PPE → Execution → Material Issue
//
// PURPOSE:
//   API service layer for Material Issue operations.
//
// RULES:
//   - API calls only
//   - No UI logic
//   - axiosClient handles JWT automatically
// ============================================================================

import axiosClient from "../../../../../api/axiosClient";


// -----------------------------------------------------------------------------
// GET: Pending Material Issues (Store Queue)
// -----------------------------------------------------------------------------
export const getPendingMaterialIssues = async () => {
  const response = await axiosClient.get(
    "/api/ppe/execution/operations/material/pending"
  );
  return response.data;
};


// -----------------------------------------------------------------------------
// GET: Operation Material Details
// -----------------------------------------------------------------------------
export const getOperationMaterialDetails = async (operationId) => {
  const response = await axiosClient.get(
    `/api/ppe/execution/operations/${operationId}/material-details`
  );
  return response.data;
};


// -----------------------------------------------------------------------------
// POST: Issue Material
// -----------------------------------------------------------------------------
export const issueMaterial = async (operationId, payload) => {
  const response = await axiosClient.post(
    `/api/ppe/execution/operations/${operationId}/material-issue`,
    payload
  );
  return response.data;
};